export default {
  validTenantIds: ["mgg_uat", "apex_uat", "mgg"],
  locales: [{ value: "en", name: "English" }, { value: "zh-HK", name: "中文" }]
};



// WEBPACK FOOTER //
// ./src/config/index.js